import type { RankedSpace } from "../types";

/**
 * AVCB / alvará flags of an original proposal room, refreshed from a fresh
 * search result (PED-14095). They are not user-editable and the client
 * badge must reflect the documents as they are now — a proposal created
 * before the flags existed, or whose AVCB expired since, would otherwise keep
 * a stale badge on the public link. Returns `null` when nothing changed.
 */
export function withFreshComplianceFlags(
  original: RankedSpace,
  fresh: RankedSpace,
): RankedSpace | null {
  if (
    original.spaceHasAvcb === fresh.spaceHasAvcb &&
    original.spaceHasOperatingPermit === fresh.spaceHasOperatingPermit
  ) {
    return null;
  }
  return {
    ...original,
    spaceHasAvcb: fresh.spaceHasAvcb,
    spaceHasOperatingPermit: fresh.spaceHasOperatingPermit,
  };
}
